import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PasswordResetForm from '@/components/Auth/PasswordResetForm';

const ResetPasswordPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md">
        <a
          href="/"
          className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-secondary transition-colors hover:text-secondary/80"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          Voltar para a página principal
        </a>
        <PasswordResetForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage;

